import React from 'react';

/**
 * Generic renderer for legal content objects (terms.js / privacy.js).
 * Content structure: { title, version, lastUpdated, sections: [{ title, paragraphs, list?, paragraphsAfterList? }] }
 */
const LegalPage = ({ content }) => {
  return (
    <div className="page-content" style={styles.container}>
      <div style={styles.inner}>
        <h1 style={styles.title}>{content.title}</h1>
        <p style={styles.meta}>
          Version {content.version} &mdash; Last updated: {content.lastUpdated}
        </p>

        {content.sections.map((section, i) => (
          <section key={i} style={styles.section}>
            <h2 style={styles.sectionTitle}>{section.title}</h2>

            {section.paragraphs?.map((p, j) => (
              <p key={j} style={styles.paragraph}>{p}</p>
            ))}

            {section.list && (
              <ul style={styles.list}>
                {section.list.map((item, j) => (
                  <li key={j} style={styles.listItem}>{item}</li>
                ))}
              </ul>
            )}

            {section.paragraphsAfterList?.map((p, j) => (
              <p key={j} style={styles.paragraph}>{p}</p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '760px',
    margin: '0 auto',
    padding: '32px 16px 64px',
  },
  inner: {},
  title: {
    fontSize: '24px',
    fontWeight: 700,
    color: '#ffffff',
    marginBottom: '4px',
  },
  meta: {
    fontSize: '11px',
    color: '#8b949e',
    marginBottom: '32px',
  },
  section: {
    marginBottom: '28px',
    borderBottom: '1px solid #2a2d3a',
    paddingBottom: '24px',
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#ffffff',
    marginBottom: '10px',
  },
  paragraph: {
    fontSize: '13px',
    color: '#c9d1d9',
    lineHeight: '1.7',
    marginBottom: '8px',
  },
  list: {
    margin: '4px 0 8px 16px',
    padding: 0,
  },
  listItem: {
    fontSize: '13px',
    color: '#c9d1d9',
    lineHeight: '1.7',
    marginBottom: '4px',
  },
};

export default LegalPage;
